import { generateReducer } from "../../common/helpers";
import {
    CUSTOMER_BALANCE_LOADING,
    CUSTOMER_BALANCE_DATA,
    CUSTOMER_BALANCE_ERROR,
} from "../constants";

const initialState = {
    byId: {}, // Stores customer balance data indexed by customerId
    loading: {}, // Tracks loading state indexed by customerId
    error: {}, // Tracks error state indexed by customerId
};

const fetchBalanceBegin = (state, { customerId }) => ({
    ...state,
    loading: { ...state.loading, [customerId]: true },
    error: { ...state.error, [customerId]: null },
});

const fetchBalanceSuccess = (state, { customerId, data }) => ({
    ...state,
    byId: { ...state.byId, [customerId]: data },
    loading: { ...state.loading, [customerId]: false },
    error: { ...state.error, [customerId]: null },
});

const fetchBalanceFailure = (state, { customerId, error }) => ({
    ...state,
    loading: { ...state.loading, [customerId]: false },
    error: { ...state.error, [customerId]: error },
});
const reducers = {
    [CUSTOMER_BALANCE_LOADING]: fetchBalanceBegin,
    [CUSTOMER_BALANCE_DATA]: fetchBalanceSuccess,
    [CUSTOMER_BALANCE_ERROR]: fetchBalanceFailure,
};
export default generateReducer(reducers, initialState);
